import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=0f18f836&scoped=true&"
import script from "./Dates.vue?vue&type=script&lang=js&"
export * from "./Dates.vue?vue&type=script&lang=js&"
import style0 from "./Dates.vue?vue&type=style&index=0&id=0f18f836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f18f836",
  null
  
)

export default component.exports